import React from 'react';
import { BooleanBadge } from '@europrocurement/flexy-components';
import { Card, Grid, TextField, Typography, useTheme } from '@mui/material';
import { UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur } from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';
import { User } from '../../../types/type';

export type UserGestionJustifProps = {
    user: User;
    handlePatchData: (
        payload: UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur,
    ) => void;
};

export const UserGestionJustif: React.FunctionComponent<UserGestionJustifProps> = function ({
    user,
    handlePatchData,
}) {
    const theme = useTheme();

    // verify the input data modification before patch to the API
    const handleInputChange = (
        event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>,
    ) => {
        const newValue = event.target.value;

        if (newValue !== user.droitUtilisateur?.usdAppsJalgestOption) {
            handlePatchData({ droitUtilisateur: { usdAppsJalgestOption: newValue } });
        }
    };

    return (
        <Card
            sx={{
                width: '100%',
                margin: '15px 0',
                padding: '15px',
                backgroundColor: theme.palette.background.paper,
            }}
        >
            <Typography
                variant="l2dh6"
                sx={{
                    borderLeft: 2,
                    borderColor: theme.palette.primary.main,
                    padding: '5px 0 5px 30px',
                    marginLeft: '-15px',
                }}
            >
                Transfert des Journaux d&apos;Annonces légales
            </Typography>
            <Grid
                sx={{
                    display: 'flex',
                    gap: '15px',
                    width: '100%',
                    margin: '10px',
                    alignItems: 'center',
                }}
            >
                <BooleanBadge
                    label="Accès à l'application JAL GEST"
                    value={user.droitUtilisateur?.usdAppsJalgest}
                    icon
                    toggleAction={() =>
                        handlePatchData({
                            droitUtilisateur: {
                                usdAppsJalgest: !user.droitUtilisateur?.usdAppsJalgest,
                            },
                        })
                    }
                />

                <Typography variant="l2dh7">Numéros des JAL à gérer :</Typography>
                <TextField
                    data-testid="jaljest-option"
                    placeholder={
                        user.droitUtilisateur?.usdAppsJalgestOption ||
                        'Numéros des journaux (ex: 2,5,10)'
                    }
                    onBlur={(event) => handleInputChange(event)}
                    defaultValue={user.droitUtilisateur?.usdAppsJalgestOption}
                    sx={{ width: '50%' }}
                />
            </Grid>
            <Typography
                variant="l2dh6"
                sx={{
                    borderLeft: 2,
                    borderColor: theme.palette.primary.main,
                    paddingLeft: '30px',
                    margin: '30px 0 0 -15px',
                }}
            >
                Application Pointage des annonces XY
            </Typography>

            <BooleanBadge
                label="Accès au pointage des annonces XY"
                value={user.droitUtilisateur?.usdAppsXy}
                icon
                toggleAction={() =>
                    handlePatchData({
                        droitUtilisateur: {
                            usdAppsXy: !user.droitUtilisateur?.usdAppsXy,
                        },
                    })
                }
                sx={{ margin: '5px 0 0 5px' }}
            />
        </Card>
    );
};
